import React from "react";
import { Link, useRouteMatch } from "react-router-dom";
import UserAccount from "./UserAccount";

const Sidebar = () => {
	let { path } = useRouteMatch();

	return (
		<div className="hidden lg:flex lg:flex-shrink-0">
			<div className="flex flex-col w-64 border-r border-gray-200 pt-5 pb-4 bg-gray-100">
				<div className="flex items-center flex-shrink-0 px-6">
					{/*<img className="h-8 w-auto"*/}
					{/*	 src="https://tailwindui.com/img/logos/workflow-logo-purple-500-mark-gray-700-text.svg"*/}
					{/*	 alt="EDC" />*/}
					<svg
						className="h-8 w-auto"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 841.9 595.3"
					>
						<g fill="#61DAFB">
							<path d="M666.3 296.5c0-32.5-40.7-63.3-103.1-82.4 14.4-63.6 8-114.2-20.2-130.4-6.5-3.8-14.1-5.6-22.4-5.6v22.3c4.6 0 8.3.9 11.4 2.6 13.6 7.8 19.5 37.5 14.9 75.7-1.1 9.4-2.9 19.3-5.1 29.4-19.6-4.8-41-8.5-63.5-10.9-13.5-18.5-27.5-35.3-41.6-50 32.6-30.3 63.2-46.9 84-46.9V78c-27.5 0-63.5 19.6-99.9 53.6-36.4-33.8-72.4-53.2-99.9-53.2v22.3c20.7 0 51.4 16.5 84 46.6-14 14.7-28 31.4-41.3 49.9-22.6 2.4-44 6.1-63.6 11-2.3-10-4-19.7-5.2-29-4.7-38.2 1.1-67.9 14.6-75.8 3-1.8 6.9-2.6 11.5-2.6V78.5c-8.4 0-16 1.8-22.6 5.6-28.1 16.2-34.4 66.7-19.9 130.1-62.2 19.2-102.7 49.9-102.7 82.3 0 32.5 40.7 63.3 103.1 82.4-14.4 63.6-8 114.2 20.2 130.4 6.5 3.8 14.1 5.6 22.5 5.6 27.5 0 63.5-19.6 99.9-53.6 36.4 33.8 72.4 53.2 99.9 53.2 8.4 0 16-1.8 22.6-5.6 28.1-16.2 34.4-66.7 19.9-130.1 62-19.1 102.5-49.9 102.5-82.3zm-130.2-66.7c-3.7 12.9-8.3 26.2-13.5 39.5-4.1-8-8.4-16-13.1-24-4.6-8-9.5-15.8-14.4-23.4 14.2 2.1 27.9 4.7 41 7.9zm-45.8 106.5c-7.8 13.5-15.8 26.3-24.1 38.2-14.9 1.3-30 2-45.2 2-15.1 0-30.2-.7-45-1.9-8.3-11.9-16.4-24.6-24.2-38-7.6-13.1-14.5-26.4-20.8-39.8 6.2-13.4 13.2-26.8 20.7-39.9 7.8-13.5 15.8-26.3 24.1-38.2 14.9-1.3 30-2 45.2-2 15.1 0 30.2.7 45 1.9 8.3 11.9 16.4 24.6 24.2 38 7.6 13.1 14.5 26.4 20.8 39.8-6.3 13.4-13.2 26.8-20.7 39.9zm32.3-13c5.4 13.4 10 26.8 13.8 39.8-13.1 3.2-26.9 5.9-41.2 8 4.9-7.7 9.8-15.6 14.4-23.7 4.6-8 8.9-16.1 13-24.1zM421.2 430c-9.3-9.6-18.6-20.3-27.8-32 9 .4 18.2.7 27.5.7 9.4 0 18.7-.2 27.8-.7-9 11.7-18.3 22.4-27.5 32zm-74.4-58.9c-14.2-2.1-27.9-4.7-41-7.9 3.7-12.9 8.3-26.2 13.5-39.5 4.1 8 8.4 16 13.1 24 4.7 8 9.5 15.8 14.4 23.4zM420.7 163c9.3 9.6 18.6 20.3 27.8 32-9-.4-18.2-.7-27.5-.7-9.4 0-18.7.2-27.8.7 9-11.7 18.3-22.4 27.5-32zm-74 58.9c-4.9 7.7-9.8 15.6-14.4 23.7-4.6 8-8.9 16-13 24-5.4-13.4-10-26.8-13.8-39.8 13.1-3.1 26.9-5.8 41.2-7.9zm-90.5 125.2c-35.4-15.1-58.3-34.9-58.3-50.6 0-15.7 22.9-35.6 58.3-50.6 8.6-3.7 18-7 27.7-10.1 5.7 19.6 13.2 40 22.5 60.9-9.2 20.8-16.6 41.1-22.2 60.6-9.9-3.1-19.3-6.5-28-10.2zM310 490c-13.6-7.8-19.5-37.5-14.9-75.7 1.1-9.4 2.9-19.3 5.1-29.4 19.6 4.8 41 8.5 63.5 10.9 13.5 18.5 27.5 35.3 41.6 50-32.6 30.3-63.2 46.9-84 46.9-4.5-.1-8.3-1-11.3-2.7zm237.2-76.2c4.7 38.2-1.1 67.9-14.6 75.8-3 1.8-6.9 2.6-11.5 2.6-20.7 0-51.4-16.5-84-46.6 14-14.7 28-31.4 41.3-49.9 22.6-2.4 44-6.1 63.6-11 2.3 10.1 4.1 19.8 5.2 29.1zm38.5-66.7c-8.6 3.7-18 7-27.7 10.1-5.7-19.6-13.2-40-22.5-60.9 9.2-20.8 16.6-41.1 22.2-60.6 9.9 3.1 19.3 6.5 28.1 10.2 35.4 15.1 58.3 34.9 58.3 50.6-.1 15.7-23 35.6-58.4 50.6zM320.8 78.4z" />
							<circle cx="420.9" cy="296.5" r="45.7" />
							<path d="M520.5 78.1z" />
						</g>
					</svg>
					<div className="text-gray-500 text-lg font-medium">EDC</div>
				</div>

				{/* Sidebar component, swap this element with another sidebar if you like */}
				<div className="h-0 flex-1 flex flex-col overflow-y-auto">
					{/* User account dropdown */}

					<UserAccount />

					{/* Sidebar Search */}
					{/*<div className="px-3 mt-5">*/}
					{/*	<label forhtml="search" className="sr-only">Search</label>*/}
					{/*	<div className="mt-1 relative rounded-md shadow-sm">*/}
					{/*		<div*/}
					{/*			className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"*/}
					{/*			aria-hidden="true">*/}
					{/*			/!* Heroicon name: search *!/*/}
					{/*			<svg className="mr-3 h-4 w-4 text-gray-400" xmlns="http://www.w3.org/2000/svg"*/}
					{/*				 viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">*/}
					{/*				<path fillRule="evenodd"*/}
					{/*					  d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"*/}
					{/*					  clipRule="evenodd" />*/}
					{/*			</svg>*/}
					{/*		</div>*/}
					{/*		<input type="text" name="search" id="search"*/}
					{/*			   className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-9 sm:text-sm border-gray-300 rounded-md"*/}
					{/*			   placeholder="Search" />*/}
					{/*	</div>*/}
					{/*</div>*/}

					{/* Navigation */}
					<nav className="px-3 mt-6">
						<div className="space-y-1">
							{/* Current: "bg-gray-200 text-gray-900", Default: "text-gray-700 hover:text-gray-900 hover:bg-gray-50" */}
							<Link
								to="/admin/dashboard"
								className={`${
									path === "/admin/dashboard"
										? "bg-gray-200 text-gray-900"
										: "text-gray-700"
								} hover:text-gray-900 hover:bg-gray-50 group flex items-center px-2 py-2 text-sm font-medium rounded-md`}
							>
								{/* Current: "text-gray-500", Default: "text-gray-400 group-hover:text-gray-500" */}
								{/* Heroicon name: home */}
								<svg
									className={`${
										path === "/admin/transactions"
											? "text-gray-500"
											: "text-gray-400 group-hover:text-gray-500"
									} mr-3 h-6 w-6`}
									xmlns="http://www.w3.org/2000/svg"
									fill="none"
									viewBox="0 0 24 24"
									stroke="currentColor"
									aria-hidden="true"
								>
									<path
										strokeLinecap="round"
										strokeLinejoin="round"
										strokeWidth="2"
										d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
									/>
								</svg>
								Dashboard
							</Link>

							<Link
								to="/admin/transactions"
								className={`${
									path === "/admin/transactions"
										? "bg-gray-200 text-gray-900"
										: "text-gray-700"
								} hover:text-gray-900 hover:bg-gray-50 group flex items-center px-2 py-2 text-sm font-medium rounded-md`}
							>
								{/* Heroicon name: view-list */}
								<svg
									className={`${
										path === "/admin/transactions"
											? "text-gray-500"
											: "text-gray-400 group-hover:text-gray-500"
									} mr-3 h-6 w-6`}
									xmlns="http://www.w3.org/2000/svg"
									fill="none"
									viewBox="0 0 24 24"
									stroke="currentColor"
									aria-hidden="true"
								>
									<path
										strokeLinecap="round"
										strokeLinejoin="round"
										strokeWidth="2"
										d="M4 6h16M4 10h16M4 14h16M4 18h16"
									/>
								</svg>
								Transactions
							</Link>

							<Link
								to="/admin/add"
								className={`${
									path === "/admin/add"
										? "bg-gray-200 text-gray-900"
										: "text-gray-700"
								} hover:text-gray-900 hover:bg-gray-50 group flex items-center px-2 py-2 text-sm font-medium rounded-md`}
							>
								{/* Heroicon name: clock */}
								<svg
									className={`${
										path === "/admin/transactions"
											? "text-gray-500"
											: "text-gray-400 group-hover:text-gray-500"
									} mr-3 h-6 w-6`}
									xmlns="http://www.w3.org/2000/svg"
									fill="none"
									viewBox="0 0 24 24"
									stroke="currentColor"
									aria-hidden="true"
								>
									<path
										strokeLinecap="round"
										strokeLinejoin="round"
										strokeWidth="2"
										d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
									/>
								</svg>
								Add Transaction
							</Link>

							<Link
								to="/admin/expense"
								className={`${
									path === "/admin/expense"
										? "bg-gray-200 text-gray-900"
										: "text-gray-700"
								} hover:text-gray-900 hover:bg-gray-50 group flex items-center px-2 py-2 text-sm font-medium rounded-md`}
							>
								{/* Heroicon name: clock */}
								<svg
									className={`${
										path === "/admin/transactions"
											? "text-gray-500"
											: "text-gray-400 group-hover:text-gray-500"
									} mr-3 h-6 w-6`}
									xmlns="http://www.w3.org/2000/svg"
									fill="none"
									viewBox="0 0 24 24"
									stroke="currentColor"
									aria-hidden="true"
								>
									<path
										strokeLinecap="round"
										strokeLinejoin="round"
										strokeWidth="2"
										d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
									/>
								</svg>
								Edit Transaction
							</Link>

							<Link
								to="/admin/jde"
								className={`${
									path === "/admin/jde"
										? "bg-gray-200 text-gray-900"
										: "text-gray-700"
								} hover:text-gray-900 hover:bg-gray-50 group flex items-center px-2 py-2 text-sm font-medium rounded-md`}
							>
								{/* Heroicon name: clock */}
								<svg
									className={`${
										path === "/admin/jde"
											? "text-gray-500"
											: "text-gray-400 group-hover:text-gray-500"
									} mr-3 h-6 w-6`}
									xmlns="http://www.w3.org/2000/svg"
									fill="none"
									viewBox="0 0 24 24"
									stroke="currentColor"
									aria-hidden="true"
								>
									<path
										strokeLinecap="round"
										strokeLinejoin="round"
										strokeWidth="2"
										d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
									/>
								</svg>
								JDE
							</Link>

							<Link
								to="/admin/bp"
								className={`${
									path === "/admin/bp"
										? "bg-gray-200 text-gray-900"
										: "text-gray-700"
								} hover:text-gray-900 hover:bg-gray-50 group flex items-center px-2 py-2 text-sm font-medium rounded-md`}
							>
								{/* Heroicon name: clock */}
								<svg
									className={`${
										path === "/admin/bp"
											? "text-gray-500"
											: "text-gray-400 group-hover:text-gray-500"
									} mr-3 h-6 w-6`}
									xmlns="http://www.w3.org/2000/svg"
									fill="none"
									viewBox="0 0 24 24"
									stroke="currentColor"
									aria-hidden="true"
								>
									<path
										strokeLinecap="round"
										strokeLinejoin="round"
										strokeWidth="2"
										d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
									/>
								</svg>
								Best Practice
							</Link>
						</div>
					</nav>
				</div>
			</div>
		</div>
	);
};

export default Sidebar;
